import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiLock, FiGlobe, FiUsers } = FiIcons;

const SecuritySection = () => {
  const securityFeatures = [
    {
      icon: FiGlobe,
      title: 'Data Residency',
      description: 'Choose where your data is stored with global compliance'
    },
    {
      icon: FiLock,
      title: 'End-to-End Encryption',
      description: 'All data encrypted at rest and in transit with AES-256'
    },
    {
      icon: FiUsers,
      title: 'Role-Based Access',
      description: 'Granular permissions and access control for your team'
    },
    {
      icon: FiShield,
      title: 'GDPR Compliant',
      description: 'Full compliance with privacy regulations and audit trails'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display font-bold text-3xl lg:text-5xl text-slate-900 mb-6">
            Enterprise-Grade Security & Privacy
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Your data and candidate privacy are protected with industry-leading security measures
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {securityFeatures.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl p-8 text-center shadow-elegant"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="w-16 h-16 bg-indigo-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={feature.icon} className="w-8 h-8 text-indigo-600" />
              </div>
              <h3 className="font-semibold text-lg text-slate-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-8 text-center text-white"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="max-w-4xl mx-auto">
            <h3 className="font-semibold text-2xl mb-4">
              Trusted by Compliance Teams Worldwide
            </h3>
            <p className="text-indigo-100 mb-6 text-lg">
              SOC 2 Type II certified • ISO 27001 compliant • Regular security audits • 99.9% uptime SLA
            </p>
            <button className="bg-white text-indigo-600 font-semibold px-8 py-3 rounded-lg hover:bg-gray-50 transition-colors">
              View Privacy Policy
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SecuritySection;